export default "__VITE_ASSET__BhURjyPN__"